import React from 'react';
import './users.css'
import Nav from '../components/layout/nav'
import Search from '../components/common/search';
import UsersTable from '../components/common/userstable';

const Users = () => {
    return ( <>
    <div className='dashboard'>

            <Nav />

            <div className='mainarea'>

                <div className='navtoppart'>

                    <div className='welcomebcakdiv'>
                        <h6 className='welcomebacktext'>Welcome back</h6>
                        <h6 className='admintitle'>Admin Dashboard</h6>
                    </div>

                    <div className='profileandnotidiv'>
                        <div className='notidiv'>
                            <div className='notiicon'></div>
                        </div>
                        <div className='profilediv'></div>
                    </div>

                </div>
                <div className='pagecenter'>

                    <div className='homecontainer'>

                        <section>
                            <div className='titlediv2'>
                                     <div className='titlediv'>
                                            <h1>Users</h1>
                                            <h2>Manage user accounts and permissions</h2>
                                        </div>
                                        <button className='exportbtn'>
                                            <div className='usersicon'></div>
                                            <h6 className='btntext'>Add User</h6>
                                        </button>
                            </div>
                           <Search 
                           search='Search users....'/>
                        <UsersTable />
                            

                           
                        </section>
                            
                    </div>
                        
                </div>
                
               
            </div>

        </div>
    </> );
}
 
export default Users;